if(!customElements.get('collection-filters') && !customElements.get('collection-filters-tags')) {
  class CollectionFiltersAbstract extends HTMLElement {
    constructor() {
      super();
      this.pageManager = this.closest('page-manager');
      this.form = this.querySelector('form');
      this.summary = this.querySelector('.summary');
      this.documentClickHandler = this.documentClick.bind(this);
      this.ajax = true;

      if(this.dataset.open) {
        this.showFilters();
      }
      this.form.addEventListener('submit', (e)=>{
        e.preventDefault();
      });
      this.pageManager.querySelector('.open-filters').addEventListener('click', ()=>{
        this.showFilters();
      });
      this.querySelector('.close-filters').addEventListener('click', ()=>{
        this.hideFilters();
      });
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.documentClickHandler);
    }

    documentClick(e) {
      if(!this.contains(e.target)) {
        this.hideFilters();
      }
    }

    isOpen() {
      return this.classList.contains('open');
    }

    showFilters() {
      $s.closeModal();
      $s.showOverlay();
      this.classList.add('open');
      $s.trapFocus(this);
      setTimeout(()=>{
        document.addEventListener('click', this.documentClickHandler);
      }, 100);
    }

    hideFilters() {
      $s.hideOverlay();
      this.classList.remove('open');
      $s.removeTrapFocus();
      document.removeEventListener('click', this.documentClickHandler);
    }
  }

  if(!customElements.get('collection-filters')) {
    class CollectionFilters extends CollectionFiltersAbstract {
      constructor() {
        super();

        this.querySelectorAll('input').forEach((option)=>{
          option.addEventListener('change', (e)=>{
            this.filterResults();
          });
        });
        this.initSummary();
      }

      initSummary() {
        if(this.summary) {
          this.summary.querySelectorAll('button').forEach((button)=>{
            button.addEventListener('click', (e)=>{
              e.preventDefault();
              if(button.dataset.optionId=='filter-price') {
                this.querySelector('#filter-price-min').value = '';
                this.querySelector('#filter-price-max').value = '';
              } else {
                if(button.dataset.clearAll) {
                  this.querySelectorAll('.group input').forEach((element)=>{
                    element.value = '';
                    element.checked = false;
                  });
                } else {
                  this.querySelector('#'+button.dataset.optionId).checked = false;
                }
              }
              this.filterResults();
            });
          });
        }
      }

      getSearchParams() {
        const formData = new FormData(this.form);
        const searchParams = new URLSearchParams(formData);

        var params = new URLSearchParams();
        const keys = Array.from(searchParams.keys()).filter((x, i, a) => a.indexOf(x)==i);
        keys.forEach((key)=>{
          let values = searchParams.getAll(key);
          if(values.find(x=>x!="")) {
            params.set(key, values.join(','));
          }
        });

        var currenSearch = new URLSearchParams(location.search);
        if(currenSearch.has('sort_by')) {
          params.set('sort_by', currenSearch.get('sort_by'));
        }

        return params;
      }

      filterResults() {
        var url;
        var params = this.getSearchParams();
        var paramsString = params.toString().replace(/%2C/g, ',');
        if(this.ajax) {
          $s.showLoadingOverlay();
          url = window.location.pathname + (paramsString ? '?'+paramsString : '');
          var isOpen = this.isOpen();
          this.pageManager.loadPage(url, ()=>{
            $s.hideLoadingOverlay();
          }, true, (doc)=> {
            if (isOpen) {
              doc.querySelector('.collection-filters').dataset.open = true;
            }
          });
        } else {
          url = window.location.pathname + (paramsString ? '?'+paramsString : '');
          location = url;
        }
      }
    }
    customElements.define('collection-filters', CollectionFilters);
  }

  if(!customElements.get('collection-filters-tags')) {
    class CollectionFiltersTags extends CollectionFiltersAbstract {
      constructor() {
        super();
        this.baseUrl = location.origin + this.dataset.baseUrl;

        this.querySelectorAll('.item a').forEach((link)=>{
          link.addEventListener('click', (e)=>{
            e.preventDefault();
            this.filterResults(link.href);
          });
        });
        this.initSummary();
      }

      initSummary() {
        if(this.summary) {
          this.summary.querySelectorAll('button').forEach((button)=>{
            button.addEventListener('click', (e)=>{
              e.preventDefault();
              if(button.dataset.clearAll) {
                var url = new URL(this.baseUrl);
                var currentUrl = new URL(location.href);
                url.search = currentUrl.search;
                this.filterResults(url.toString());
              } else {
                this.querySelector('#'+button.dataset.optionId).closest('a').dispatchEvent(new Event('click', {bubbles: true}));
              }
            });
          });
        }
      }

      filterResults(url) {
        if(this.ajax) {
          $s.showLoadingOverlay();
          this.pageManager.loadPage(url, ()=>{
            $s.hideLoadingOverlay();
          });
        } else {
          location = url;
        }
      }
    }
    customElements.define('collection-filters-tags', CollectionFiltersTags);
  }
}

if(!customElements.get('collection-sort')) {
  class CollectionSort extends HTMLElement {
    constructor() {
      super();
      this.focusStorageKey = 'collection-sort-restore-focus';
      this.pageManager = this.closest('page-manager');
      this.dropdown = this.querySelector('#sort-by');
      this.ajax = true;
      var elementGrid = document.querySelector(".collection-grid");
      var featuredItem = document.querySelector(".featured-item");
      var productItems = elementGrid.querySelectorAll(".product-item");
      var currentConcern = "shop-all";
      var currentType = "shop-all";
      var search = new URLSearchParams(location.search)
      this.dropdown.value = search.get('sort_by') || this.dataset.sortBy;
      this.restoreSortFocus();

      this.dropdown.addEventListener('change', ()=>{
        var search = new URLSearchParams(location.search); //get new instance
        search.set('sort_by', this.dropdown.value);
        search.delete('page');
        var paramsString = search.toString();
        var selectConcern = document.querySelector(".concern-filter");
        currentConcern = selectConcern ? selectConcern.value : null;
        console.log("------")
        console.log(currentConcern)
        if(this.ajax) {
          $s.showLoadingOverlay();
          const url = window.location.pathname + (paramsString ? '?'+paramsString : '');
          this.pageManager.loadPage(url, ()=>{
            $s.hideLoadingOverlay();
            this.focusSortControl();
          });
        } else {
          sessionStorage.setItem(this.focusStorageKey, 'true');
          location.search = paramsString;
        }
        setTimeout(() => {
          var concernFilter = document.querySelector('.concern-filter');
          if (!concernFilter || !currentConcern) return;
          console.log("CHECKING")
          currentType = document.querySelector(".filter-button.active").value;
          concernFilter.value = currentConcern
          var event = new Event('change');

          // Dispatch it.
          concernFilter.dispatchEvent(event);
        }, 1000);
      });
    }

    getVisibleSortDropdown() {
      var dropdowns = document.querySelectorAll('collection-sort select');
      for (var i = 0; i < dropdowns.length; i++) {
        var dropdown = dropdowns[i];
        if (dropdown.disabled) continue;
        if (dropdown.offsetWidth || dropdown.offsetHeight || dropdown.getClientRects().length) {
          return dropdown;
        }
      }
      return dropdowns[0] || null;
    }

    focusSortControl() {
      var dropdown = this.getVisibleSortDropdown();
      if (!dropdown) return;
      setTimeout(function() {
        dropdown.focus();
      }, 0);
    }

    restoreSortFocus() {
      if (sessionStorage.getItem(this.focusStorageKey) !== 'true') return;
      sessionStorage.removeItem(this.focusStorageKey);
      this.focusSortControl();
    }
  }
  customElements.define('collection-sort', CollectionSort);
}



if(!customElements.get('js-collection-filters')) {
  class JsCollesctionFilters extends HTMLElement {
    constructor() {
      super();
      var elementGrid = this.parentElement.querySelector(".collection-grid");
      var featuredItem = this.parentElement.querySelector(".featured-item");
      var productItems = elementGrid.querySelectorAll(".product-item");

      var filterButtons = this.querySelectorAll(".filter-button");

      var currentConcern = "shop-all";
      var currentType = "shop-all";

      var shopAllButton = this.querySelector(".shop-all");
      var lastButtonActive = shopAllButton;

      filterButtons.forEach(filterButton => {
        filterButton.addEventListener('click', ()=>{
          currentType = filterButton.getAttribute("value");
          filterButton.classList.add('active');
          lastButtonActive.classList.remove('active');
          if(lastButtonActive == filterButton){
            shopAllButton.classList.add('active');
            currentType = "shop-all";
            lastButtonActive = shopAllButton;
          }
          else{
            lastButtonActive = filterButton;
          }
          filterChanged();
        });
      });

      var selectConcern = this.querySelector(".concern-filter");
      selectConcern.addEventListener("change", ()=>{
        currentConcern = selectConcern.value;
        filterChanged();
      })

      function filterChanged(){
        var counterPosition = 0;
        var positionFound = false;

        productItems.forEach((product,index) => {
          product.classList.remove('hide');
          if(!product.hasAttribute(currentConcern) || !product.hasAttribute(currentType)) {
            product.classList.add('hide');
          }
          else
          {
            counterPosition++;
          }
          if(featuredItem)
          {
            if((counterPosition == 5 || index == productItems.length - 1) && !positionFound)
            {
              positionFound = true;
              var newOrder = index == productItems.length -1 ? productItems.length + 1 : index + 1;
              featuredItem.style.setProperty('order', newOrder, 'important');

            }
          }
        });


        if(AOS) AOS.refresh();
      }
    }
  }
  customElements.define('js-collection-filters', JsCollesctionFilters);
}
